import { Injectable } from '@angular/core'
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { NbAuthService } from '../../@nebular/auth'
import { getAuthUser } from '../../utils'

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: NbAuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authService.isAuthenticated().do((authenticated) => {
      if (!authenticated) {
        this.router.navigate(['auth/login'], { queryParams: { returnUrl: state.url } })
      } else {
        const user = getAuthUser()

        if (!user || !user.role) {
          this.router.navigate(['auth/login'], { queryParams: { returnUrl: state.url } })
          return
        }

        if (user.role === 'admin') {
          return
        }

        if (user.role === 'dj') {
          const url = state.url

          if (
            !(
              url.includes('/pages/music/submitted-mixes/dj') ||
              url.includes('/pages/music/mix/') ||
              url.includes('/pages/music/mix/0/admin') ||
              url.includes('/pages/music/mixes/admin')
            )
          ) {
            this.router.navigate(['pages/music/submitted-mixes/dj'], {})
          }
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// /srv/staging/FitRadioAdmin2/src/app/@core/security/auth-guard.service.ts